// Which authoring surface produced a message's `editor_state`. The app re-exports this; see
// `ChannelType` (`channel-type.ts`) for the same leaf-enum-in-lib pattern.
export enum EditorType {
  DragAndDrop = "dragAndDrop",
  Html = "html",
  Agent = "agent",
  Sms = "sms",
  Push = "push",
  InApp = "inApp",
  Whatsapp = "whatsapp",
}
